module.exports = __webpack_public_path__ + "img/shequnhuiyuan.c0d74b27.png";